const StudioOutlineIllustration = () => (
  <svg
    width="288"
    height="176"
    viewBox="0 0 288 176"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3">
      <rect
        x="139.5"
        y="0.5"
        width="64"
        height="41"
        rx="5.5"
        className="stroke-fg-secondary/30"
      />
    </g>
    <rect
      x="0.5"
      y="0.5"
      width="64"
      height="41"
      rx="5.5"
      className="stroke-fg-secondary/30"
    />
    <rect
      x="6"
      y="10"
      width="9"
      height="1"
      rx="0.5"
      className="fill-fg-secondary/30"
    />
    <rect
      x="8.5"
      y="30.5"
      width="9.75"
      height="4"
      rx="0.5"
      className="stroke-fg-secondary/30"
    />
    <rect
      x="21.25"
      y="28.5"
      width="9.75"
      height="6"
      rx="0.5"
      className="stroke-fg-secondary/30"
    />
    <rect
      x="34"
      y="22.5"
      width="9.75"
      height="12"
      rx="0.5"
      className="stroke-fg-secondary/30"
    />
    <rect
      x="46.75"
      y="16.5"
      width="9.75"
      height="18"
      rx="0.5"
      className="stroke-fg-secondary/30"
    />
    <rect
      x="6"
      y="7"
      width="17"
      height="1"
      rx="0.5"
      className="fill-fg-secondary/30"
    />
    <g opacity="0.3">
      <rect
        x="0.5"
        y="99.5"
        width="64"
        height="48"
        rx="5.5"
        className="stroke-fg-secondary/30"
      />
    </g>
    <g opacity="0.3">
      <rect
        x="69.5"
        y="99.5"
        width="64"
        height="48"
        rx="5.5"
        className="stroke-fg-secondary/30"
      />
    </g>
    <g opacity="0.3">
      <rect
        x="140.5"
        y="99.5"
        width="64"
        height="48"
        rx="5.5"
        className="stroke-fg-secondary/30"
      />
    </g>
    <rect
      x="69.5"
      y="0.5"
      width="65"
      height="41"
      rx="5.5"
      className="stroke-fg-secondary/30"
      strokeDasharray="2 2"
    />
    <g opacity="0.6">
      <rect
        x="0.5"
        y="46.5"
        width="64"
        height="48"
        rx="5.5"
        className="stroke-fg-secondary/30"
      />
      <rect
        x="6"
        y="53"
        width="20"
        height="1"
        rx="0.5"
        className="fill-fg-secondary/30"
      />
      <path
        d="M32 71.6455L32.0781 71.7676L37.9639 81.0479C36.3543 81.971 34.4897 82.5 32.5 82.5C26.4249 82.5 21.5 77.5751 21.5 71.5C21.5 65.5925 26.157 60.7741 32 60.5127V71.6455ZM41.8037 65.6309C42.8775 67.3293 43.5 69.3411 43.5 71.5C43.5 75.2274 41.6453 78.5205 38.8076 80.5107L33.1777 71.6367L41.8037 65.6309ZM33 60.5117C36.3534 60.6617 39.3148 62.3133 41.2314 64.8115L33 70.542V60.5117Z"
        className="stroke-fg-secondary/30"
      />
    </g>
    <g opacity="0.3">
      <rect
        x="69.5"
        y="46.5"
        width="64"
        height="48"
        rx="5.5"
        className="stroke-fg-secondary/30"
      />
    </g>
    <g opacity="0.3">
      <rect
        x="140.5"
        y="46.5"
        width="64"
        height="48"
        rx="5.5"
        className="stroke-fg-secondary/30"
      />
    </g>
    <rect
      x="74.992"
      y="23.3396"
      width="62.1992"
      height="40.737"
      rx="5.5"
      transform="rotate(-8 74.992 23.3396)"
      className="fill-white dark:fill-neutral-800"
    />
    <rect
      x="74.992"
      y="23.3396"
      width="62.1992"
      height="40.737"
      rx="5.5"
      transform="rotate(-8 74.992 23.3396)"
      className="stroke-fg-secondary/30"
    />
    <rect
      x="81.8157"
      y="28.9446"
      width="17"
      height="1"
      rx="0.5"
      transform="rotate(-8 81.8157 28.9446)"
      className="fill-fg-secondary/30"
    />
    <path
      d="M86.7965 55.2069L93.0316 48.9696C94.6869 47.3138 97.0342 46.5495 99.347 46.9133C101.519 47.2549 103.729 46.6027 105.367 45.1367L105.563 44.9612C107.024 43.654 108.919 42.9385 110.879 42.9546L114.873 42.9873C117.623 43.0098 120.233 41.7734 121.958 39.6306L129.993 29.6471"
      className="stroke-fg-secondary/30"
      strokeLinecap="round"
    />
    <rect
      x="82.1968"
      y="31.6565"
      width="9"
      height="1"
      rx="0.5"
      transform="rotate(-8 82.1968 31.6565)"
      className="fill-fg-secondary/30"
    />
  </svg>
)

export default StudioOutlineIllustration
